export { default } from './DescriptionWithBackground';
